import { createDataProvider } from '@vlaio/shared/core';

import { TrackingApiService, TrackingService } from './services';

export const provideTrackingData = createDataProvider(TrackingApiService, TrackingService);
